import { render } from "./ProductCreating.vue?vue&type=template&id=7a736a20&ts=true"
import script from "./ProductCreating.vue?vue&type=script&lang=ts"
export * from "./ProductCreating.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/lmd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__